export default __webpack_public_path__ + "static/asesor-one-88f4ba06fc39bc2accb4760e01ac6323.png";